import React from 'react'
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useKeyDown } from '../../../hooks/useKeyDown';
import KudzuLogo from '../../../assets/kudzu-plus-images/kudzu-add-money.png';
import Arrow from '../../../assets/kudzu-plus-images/Arrow_AddMoney.png'
     
const KudzuPlusExitModal = ({ content1, btn1, btn1Function, btn2, btn2Function, icon = false }) => {
   
    useKeyDown(() => {
        btn1Function();
    }, ["Enter"])
   

    return (
        <div className=' flex flex-col justify-center items-center w-full'>
            <p className={`font-hanken-grotesk lg:text-[19px] md:text-[19px] sm:text-[16px] ${icon ? "mb-0" : "mb-44"} text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[#ffffff]`}>{content1}</p>
            <div className='mb-10'>
                {icon ? (<img src={KudzuLogo} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 mb-[20%] sm:my-10 my-10' />)
                    :
                    (<></>)
                }
            </div>


                    <div className="flex justify-between items-center w-full px-4 py-2">
  <button
    className="font-hanken-grotesk text-[#779CE5] text-[20px] font-medium leading-[24px] cursor-pointer"
    onClick={() => btn1Function()}
    onKeyDown={(e) => { if (e.key === "Enter") btn1Function(); }}
  >
    {btn1}
  </button>


  {btn2 && (
    <button
      className="font-hanken-grotesk text-[20px] font-medium leading-[24px] cursor-pointer flex items-center gap-1 text-white"
      onClick={() => btn2Function()}
      onKeyDown={(e) => { if (e.key === "Enter") btn2Function(); }}
    >
      {btn2}
      <img src={Arrow} alt="arrow" className="w-[16px] h-[16px] object-contain" />
    </button>
  )}
</div>



        </div>
    )
}


export default withOidcSecure(KudzuPlusExitModal)
